import React from "react";
import PropTypes from "prop-types";
import lodash from "lodash";

class Search extends React.Component {
  state = {
    searchText: ""
  };

  componentWillMount() {
    this.__delay = lodash.debounce(this.callCallback, 400);
  }

  callCallback = () => this.props.newSearchCallback(this.state.searchText);

  onSearchChanged = e => {
    this.setState({ searchText: e.target.value });

    if (!e.target.value || e.target.value.length >= 3) {
      this.__delay();
    }
  };

  render() {
    return (
      <div className={this.props.fieldClassName}>
        <input
          role="search"
          className="form-control"
          placeholder={this.props.placeholder}
          value={this.state.searchText}
          onChange={e => this.onSearchChanged(e)}
          aria-label="Search Input Field"
        />
      </div>
    );
  }
}

Search.propTypes = {
  fieldClassName: PropTypes.string
};

Search.defaultProps = {
  fieldClassName: "col-md-3 col-xs-12",
  placeholder: "Search... (3 characters or more)"
};

export default Search;
